import axios from "axios";
import type { ApiProblem } from "@/lib/types";

/**
 * Extrae un mensaje humano legible de cualquier error (Axios, Error, otro).
 * Usado por todos los `onError` de mutations para feedback consistente.
 */
export function extractApiMessage(err: unknown, fallback = "Error"): string {
  if (axios.isAxiosError<ApiProblem>(err)) {
    return (
      err.response?.data?.detail ??
      err.response?.data?.title ??
      err.message ??
      fallback
    );
  }
  return err instanceof Error ? err.message : fallback;
}
